import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import PageHeader from "@/components/feature/PageHeader";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/siteData";

export default function Faq() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: "/faq" },
        ],
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: { "@type": "Answer", text: f.answer },
        })),
      },
    ],
  };

  return (
    <>
      <Seo
        title="洞洞杂货铺常见问题｜店主是谁·主要人物·洞的秘密"
        description="洞洞杂货铺常见问题解答：店主是谁、主要人物有哪些、墙上的洞是做什么的、在哪里看正版……入坑前先来这里扫盲。"
        keywords="洞洞杂货铺常见问题,洞洞杂货铺店主,洞洞杂货铺主要人物,洞的秘密"
        path="/faq"
        jsonLd={jsonLd}
      />
      <PageHeader
        crumb={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
        title="常见问题"
        subtitle="关于《洞洞杂货店》最常被问到的几个问题，答案都整理在这里。"
      />

      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
          <FaqAccordion items={faqs} />

          <div className="mt-10 rounded-lg border border-background-200/70 bg-background-100 p-6 text-center">
            <h2 className="font-heading text-lg font-bold text-foreground-950">还有别的疑问？</h2>
            <p className="mt-2 text-sm text-foreground-600">
              想进一步了解角色与设定，可以翻翻资料页，或者直接去正版平台追更。
            </p>
            <div className="mt-4 flex flex-col justify-center gap-3 sm:flex-row">
              <Link
                to="/characters"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                角色介绍
              </Link>
              <Link
                to="/settings"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-accent-700 transition-colors hover:bg-accent-50"
              >
                店铺设定
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}